if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						if (item.classList.contains('is-parent')) {
							const parentId = item.querySelector('.parent-product').dataset.parentId;
							let bundle = {}
							bundle[item.dataset.id] = 0;

							this.querySelectorAll('.linked-product').forEach(linkedProduct=>{
								if ( linkedProduct.dataset.linkedId == parentId ) {
									const linkedProductCartItem = linkedProduct.closest('.cart-item') || linkedProduct.closest('.cart-form-item');
									bundle[linkedProductCartItem.dataset.id] = 0;
								}
							})
							this.updateCartQty(bundle, 0, true);
						} else {
							this.updateCartQty(item, 0, false);
						}
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						console.info('input');
						e.preventDefault();
						e.target.blur();
						if (item.classList.contains('is-parent')) {
							const parentId = item.querySelector('.parent-product').dataset.parentId;
							let bundle = {}
							bundle[item.dataset.id] = parseInt(qty.value);

							this.querySelectorAll('.linked-product').forEach(linkedProduct=>{
								if ( linkedProduct.dataset.linkedId == parentId ) {
									const linkedProductCartItem = linkedProduct.closest('.cart-item') || linkedProduct.closest('.cart-form-item');
									bundle[linkedProductCartItem.dataset.id] = parseInt(qty.value);									
								}
							})
							this.updateCartQty(bundle, parseInt(qty.value), true);
						} else {
							this.updateCartQty(item, parseInt(qty.value), false);
						}
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		async updateCartQty(item, newQty, isItemBundle){

			let alert = null;
			let outOfStock = false;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const updateCart = async (updates) => {
				const bundleItems = Object.entries(updates);
				const originalQuantities = {};

				const cartResponse = await fetch('/cart.js', {
					method: 'GET',
					headers: { 'Accept': 'application/json' }
				}).then(res => res.json());

				const cartItems = cartResponse.items;
				cartItems.forEach(item => {
					originalQuantities[item.id] = item.quantity;
				});
	
				for (const [id, quantity] of bundleItems) {

					const body = JSON.stringify({
						'id': id,
						'quantity': quantity
					});
		
					const response = await fetch(KROWN.settings.routes.cart_change_url, {
						method: 'POST',
						headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
						body
					}).then(res => res.json());
		
					if (response.status == 422) {
						// wrong stock logic alert
						outOfStock = true; 
						if (!alert) {
							alert = document.createElement('span');
							alert.classList.add('alert', 'alert--error');
						}
						if (typeof response.description === 'string') {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}

						 // Revert the previously updated items to their original quantities
						 for (const [revertId, originalQuantity] of Object.entries(originalQuantities)) {
							const revertBody = JSON.stringify({
								'id': revertId,
								'quantity': originalQuantity
							});
			
							await fetch(KROWN.settings.routes.cart_change_url, {
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body: revertBody
							}).then(res => res.json());
						}			
						break; 
					}
				}
			};

			const changeCart = async (item, newQty) => {
				const body = JSON.stringify({
					line: parseInt(item.dataset.line),
					quantity: newQty
				});
		
				const response = await fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				}).then(res => res.json());
		
				if (response.status == 422) {
					// wrong stock logic alert
					outOfStock = true;
					if (!alert) {
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
					}
					if (typeof response.description === 'string') {
						alert.innerHTML = response.description;
					} else {
						alert.innerHTML = response.message;
					}
				}
			};

			try {
				if (isItemBundle) {
					await updateCart(item);
				} else {
					await changeCart(item, newQty);
				}
		
				const response = await fetch('?section_id=helper-cart');
				const text = await response.text();
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
		
				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();
		
				document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
					elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
				});
				document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
					elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
				});
		
				if (outOfStock && alert !== null) { 
					this.form.prepend(alert);
				}
		
				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
		
				const event = new Event('cart-updated');
				this.dispatchEvent(event);
				document.dispatchEvent(new CustomEvent('cart:updated'));
			} catch (e) {
				console.log(e);
				let alert = document.createElement('span');
				alert.classList.add('alert', 'alert--error');
				alert.textContent = KROWN.settings.locales.cart_general_error;
				this.form.prepend(alert);
			} finally {
				this.form.classList.remove('processing');
			}
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				if (this.closest('[data-js-cart-item]').classList.contains('is-parent')) {
					const parentId = this.closest('[data-js-cart-item]').querySelector('.parent-product').dataset.parentId;
					let bundle = {}
					bundle[this.closest('[data-js-cart-item]').dataset.id] = parseInt(this.querySelector('.qty').value);

					document.getElementById('AjaxCartForm').querySelectorAll('.linked-product').forEach(linkedProduct=>{
						if ( linkedProduct.dataset.linkedId == parentId ) {
							const linkedProductCartItem = linkedProduct.closest('.cart-item') || linkedProduct.closest('.cart-form-item');
							bundle[linkedProductCartItem.dataset.id] = parseInt(this.querySelector('.qty').value);
						}
					})
					document.getElementById('AjaxCartForm').updateCartQty(bundle, parseInt(this.querySelector('.qty').value), true);
				} else {
					document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value), false);
				}
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}